import PropTypes from 'prop-types';
import styles from './FJTextToImageRatio.module.less';
import ArrowIcon from '../../../../assets/svg/button-right.svg?react';
import FJTextToImageDataConfig from '../../../../config/dataConfig/FJTextToImageDataConfig';
import { useMemo, useState } from 'react';
import FJVerticalScroller from '../../../../common/components/FJScroller/FJVerticalScroller';
import CheckIcon from '../../../../assets/svg/choose.svg?react';
import classNames from 'classnames';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew';
import FJConstant from '../../../../constants/FJConstant.js';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip.jsx';

const FJTextToImageRatio = ({
    curRatio,
    changeRatio,
    curModelObj,
    boxStyle,
    type,
    placement = 'rightTop',
    offsetLeft = 20,
    offsetTop = -21,
}) => {
    const [showSideModel, setShowSideModel] = useState(false);

    const handleOnMouseDown = e => {
        showSideModel && e.stopPropagation();
    };

    const handleChangeRatio = ratio => {
        changeRatio(ratio);
    };

    const supportRatios = useMemo(() => {
        if (!curModelObj?.supportRatios) {
            return null;
        }
        const model = FJTextToImageDataConfig.RATIO_LIST.filter(item => curModelObj?.supportRatios.includes(item.name));
        return model;
    }, [curModelObj]);

    const curRatioObj = useMemo(() => {
        return supportRatios?.find(item => item.name === curRatio);
    }, [curRatio, supportRatios]);

    if (!supportRatios) {
        return null;
    }
    const _renderTrigger = ({ ref, onClick }) => {
        if (type === FJConstant.FOOTER) {
            return (
                <FJToolTip title='aspect-ratio'>
                    <div className={styles.icon_box} ref={ref} onClick={onClick}>
                        {FJLocalStore._(curRatioObj.name === 'auto' ? 'auto-footer' : curRatioObj.name)}
                    </div>
                </FJToolTip>
            );
        }
        return (
            <div className={styles.ratio_btu} onClick={onClick} onMouseDown={handleOnMouseDown} ref={ref}>
                {curRatioObj && (
                    <>
                        {curRatioObj.renderIcon?.({ className: styles.ratio_icon })}
                        {FJLocalStore._(curRatioObj.name)}
                    </>
                )}
                <ArrowIcon className={classNames(styles.arrow_icon, { [styles.arrow_icon_active]: showSideModel })} />
            </div>
        );
    };
    const _renderOverlay = ({ ref }) => {
        return (
            <div className={styles.ratio_side_model} ref={ref}>
                <div className={styles.model_ratio_title}>{FJLocalStore._('aspect-ratio')}</div>
                <FJVerticalScroller className={styles.ratio_list_box}>
                    {supportRatios.map(item => {
                        return (
                            <div
                                className={classNames(styles.ratio_item, {
                                    [styles.ratio_item_active]: item.name === curRatioObj?.name,
                                })}
                                key={item.name}
                                onClick={() => handleChangeRatio(item)}
                            >
                                {item.renderIcon?.({ className: styles.ratio_item_icon })}
                                <div className={styles.ratio_item_name}>{FJLocalStore._(item.name)}</div>
                                {item.name === curRatioObj?.name && <CheckIcon className={styles.check_icon} />}
                            </div>
                        );
                    })}
                </FJVerticalScroller>
            </div>
        );
    };
    return (
        <>
            {type === FJConstant.FOOTER ? (
                <FJDropdownNew
                    renderTrigger={_renderTrigger}
                    renderOverlay={_renderOverlay}
                    offsetLeft={offsetLeft}
                    offsetTop={offsetTop}
                    zIndex={999}
                    trigger='click'
                    placement={placement}
                    useAnchorBody
                    canTriggerActive
                    onHide={() => setShowSideModel(false)}
                    onShow={() => setShowSideModel(true)}
                />
            ) : (
                <div className={styles.ratio_box} style={boxStyle}>
                    <div className={styles.ratio_title}>{FJLocalStore._('aspect-ratio')}</div>
                    <FJDropdownNew
                        renderTrigger={_renderTrigger}
                        renderOverlay={_renderOverlay}
                        offsetLeft={offsetLeft}
                        offsetTop={-10}
                        zIndex={999}
                        trigger='click'
                        placement={placement}
                        useAnchorBody
                        canTriggerActive
                        onHide={() => setShowSideModel(false)}
                        onShow={() => setShowSideModel(true)}
                        fitInViewAnyway
                    />
                </div>
            )}
        </>
    );
};

FJTextToImageRatio.propTypes = {
    curRatio: PropTypes.string,
    changeRatio: PropTypes.func,
    curModelObj: PropTypes.object,
    boxStyle: PropTypes.object,
};

export default FJTextToImageRatio;
